<div>Build Version - {{buildVersion}}</div>
<div>Angular Version - {{webPackageVersion}}</div>
